<template>
  <v-alert
  :type="alertType"
  class="text-white">
    {{ value }}
    <span style="font-size: smaller; float: right">({{ min }} - {{ max }})</span>
  </v-alert>
</template>

<script>
export default {
  name: 'ColouredValueTotalTime',
  props: ['value', 'min', 'max'],
  computed: {
    actual() {
      const { value } = this;
      if (value?.length > 2) {
        const arr = value.split(':');
        return parseFloat(arr[0]);
      }
      return 0;
    },
    isSuccess() {
      return this.actual >= this.min && this.actual <= this.max;
    },
    isError() {
      return this.actual < this.min || this.actual > this.max;
    },
    alertType() {
      if (this.isSuccess) {
        return 'success';
      }
      return 'error';
    },
  },
};
</script>
<style scoped>
.text-success {
  color: green;
}
.text-error {
  color: red;
}
</style>
